<template>

      <FlashNotifications ref="flash" />
        <div class="h-[57vh] mt-2 overflow-y-auto pl-7 pr-4 scrollbar-style">
                  <div class="">
                    <div class="flex">
                        <div class="flex w-10">
                            <div class="w-[14px] h-[14px] inline-block"></div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div
                              class="g-form border-b border-gray-500 text-gray-600 hover:text-gray-900 relative dark:text-gray-400 dark:hover:text-gray-100"
                            >
                              <input
                                ref="titleInputField"
                                @focus="onTitleInputFocus"
                                @blur="onTitleInputBlur"
                                class="bg-transparent text-2xl w-full border-none px-3 py-1 focus:ring-transparent"
                                placeholder="Add title"
                                type="text"
                                autocomplete="off"
                              />
                              <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="flex items-center mt-4">
                        <div class="flex w-10">
                            <div class="">
                                <svg class="w-5 h-5 fill-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11 12h6v6h-6z"></path><path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z"></path></svg>
                            </div>
                        </div>
                        <div class="flex flex-grow">
                            <TimelydoDropdown
                              title=""
                              name="locale"
                              selected_value=""
                              :values="useCalendarStoreObj().calendars_list"
                              :opts="{placeholder: 'Select a calendar'}"
                            >
                            </TimelydoDropdown>
                        </div>
                  </div>
                  <div class="flex mt-7">
                        <div class="flex w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5 fill-gray-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path><path d="M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="flex items-center ">
                                <div>
                                    <v-date-picker v-model="target_date" 
                                        :popover="{ visibility: 'focus' }" 
                                        mode="date" 
                                    >
                                        <template #default="{ inputValue, inputEvents }">
                                            <div class="flex gap-4 w-full">
                                                <div>
                                                    <div class="form-group">
                                                        <input 
                                                            id="filter-date-range" 
                                                            ref="filterDateRange" 
                                                            type="text" 
                                                            name="range" 
                                                            class="bg-gray-50 hover:bg-gray-100 border border-gray-50 text-gray-900 w-48 text-sm rounded ring-0 appearance-none focus:ring-transparent block px-1 py-2.5 dark:bg-gray-700 dark:border-gray-500 dark:text-gray-400 dark:placeholder-gray-400 date-gray-400" 
                                                            :value="formattedDate" 
                                                            v-on="inputEvents" 
                                                            autocomplete="off"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </v-date-picker>
                                </div>
                                <div class="ml-2">
                                    <div class="flex items-center w-full">
                                        <CustomSlotsDropdown
                                          name="start"
                                          :selected_value="target_time.start"
                                          :values="generateStartTimeSlots()"
                                          @change="updateSlotDropdownValue"
                                        >
                                        </CustomSlotsDropdown>

                                        
                                        <p class="px-1 pb-1 dark:text-gray-400">-</p>
                                        <CustomSlotsDropdown
                                          name="end"
                                          :selected_value="target_time.end"
                                          :values="generateEndTimeSlots()"
                                          @change="updateSlotDropdownValue"
                                        >
                                        </CustomSlotsDropdown>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
                  <div class="flex my-5">
                        <div class="flex w-10">
                            <div class="mt-2">
                                <svg class="w-5 h-5 fill-gray-500" viewBox="0 0 24 24"><path d="M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4c-.43 0-.84-.09-1.23-.21-.03-.01-.06-.02-.1-.03A5.98 5.98 0 0 0 15 8zm1.66 5.13C18.03 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.58-3.47-6.34-3.87zM9 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 9c-2.7 0-5.8 1.29-6 2.01V18h12v-1c-.2-.71-3.3-2-6-2M9 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 9c2.67 0 8 1.34 8 4v3H1v-3c0-2.66 5.33-4 8-4z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <SearchContactsDropdown @change="updateAttendeeEmail"></SearchContactsDropdown>
                        </div>
                  </div>
                  <div class="flex">
                        <div class="flex w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><title>Google Meet logo</title><path d="M24 4.904v14.355c-.045.04-.032.098-.051.146-.186.485-.832.735-1.31.335-1.043-.874-2.092-1.744-3.139-2.615l-.438-.364v3.606c0 .237-.045.468-.147.682-.285.598-.759.92-1.412.975-.035 0-.07-.003-.102-.003H5.722c-.035 0-.07-.004-.102-.004V16.427c0-.036 0-.072-.003-.104l.013-.013.048.003c2.605 0 5.21 0 7.815.003.077 0 .083-.026.083-.094-.003-1.369 0-2.733 0-4.1 0-.036.003-.072.003-.105.013.008.032.01.042.02.262.224.522.451.781.68l.714.622c.278.244.56.481.838.725.195.17.39.341.59.51.236.205.473.406.71.614.24.208.476.416.713.624.247.215.493.429.74.64.108.094.22.188.345.295V7.41c.007-.01.01-.02.016-.03l.051-.04a2268.9 2268.9 0 003.515-2.926.78.78 0 01.684-.188.8.8 0 01.596.448c.038.069.057.15.086.23z" fill="#00ab47"/><path d="M5.63 16.31l-.013.013c-.023 0-.042-.004-.064-.004H0v-8.64l.006-.005.007.003c.029 0 .057.004.086.004h5.438c.025 0 .054 0 .08-.003.003.003.006.01.01.013v8.56c0 .023 0 .04.003.059z" fill="#2683fb"/><path d="M0 16.319h5.553c.022 0 .041.003.064.003 0 .036.003.072.003.104v5.59c-.035 0-.07.004-.102.004H1.754c-.067 0-.135 0-.199.004a1.417 1.417 0 01-.432-.085C.56 21.73.198 21.334.045 20.744c-.016-.063-.013-.128-.042-.186C0 19.145 0 17.732 0 16.319z" fill="#0066d9"/><path d="M1.552 22.037v-.013c.067 0 .135-.004.199-.004h3.763c.036 0 .07-.004.103-.004.035 0 .07.003.102.003h11.679c.035 0 .07.004.102.004v.013z" fill="#bee9d0"/><path d="M5.617 1.98v-.016h11.89v.013l-.103.002z" fill="#feedbe"/><path d="M5.617 1.98H17.4c.035 0 .07-.003.102-.003.74.052 1.325.54 1.507 1.25.036.134.052.27.052.407v3.635c0 .035.003.07.006.103l-.016.03a.649.649 0 00-.058.041L14.4 11.31c-.272.23-.548.459-.82.686 0-.04-.003-.074-.003-.113V7.798c0-.11 0-.11-.106-.11H5.713a.773.773 0 00-.087.006c-.003-.003-.006-.01-.01-.013 0-.026.004-.055.004-.08V2.07l-.003-.08c-.004-.003 0-.007 0-.01z" fill="#feb900"/><path d="M13.58 12.014c0-.002-.004-.006-.004-.012 0-.004 0-.004.003-.008.272-.226.548-.453.82-.684 1.533-1.29 3.066-2.577 4.596-3.867a.649.649 0 01.057-.041v9.338c-.125-.106-.237-.197-.345-.294l-.74-.64c-.237-.209-.473-.417-.713-.625l-.71-.614c-.196-.169-.391-.34-.59-.51-.278-.24-.56-.48-.838-.724-.24-.208-.477-.416-.714-.624-.26-.227-.522-.45-.78-.679-.01-.006-.027-.01-.043-.016z" fill="#00832d"/><path d="M5.614 1.99l.003.082v5.53l-.003.08-.08.003H.097c-.03 0-.058-.003-.087-.003l.051-.062a5751.59 5751.59 0 005.495-5.574c.02-.02.039-.036.058-.056z" fill="#e84235"/></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="flex justify-between items-center ">
                                <a class="bg-blue-600 rounded px-4 py-2 text-sm text-white focus:outline-none focus-visible:outline-2 hover:text-slate-100 hover:bg-blue-500 inline-flex items-center justify-center"
                                     
                                     href="#">
                                    <span> Add Google Meet video conferencing</span>
                                </a>
                            </div>
                        </div>
                  </div>
                  <div class="flex mt-4">
                        <div class="flex w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5 fill-gray-500"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m12 22 1-2v-3h5a1 1 0 0 0 1-1v-1.586c0-.526-.214-1.042-.586-1.414L17 11.586V8a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v3a1 1 0 0 0 1 1v3.586L5.586 13A2.01 2.01 0 0 0 5 14.414V16a1 1 0 0 0 1 1h5v3l1 2zM8 4h8v2H8V4zM7 14.414l1.707-1.707A.996.996 0 0 0 9 12V8h6v4c0 .266.105.52.293.707L17 14.414V15H7v-.586z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div
                              class="g-form relative text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 rounded hover:cursor-pointer hover:text-gray-900 relative dark:text-gray-300 dark:hover:text-gray-100"
                            >
                              <input
                                class="bg-transparent w-full border-none py-1 focus:ring-transparent"
                                placeholder="Add Location"
                                type="text"
                                autocomplete="off"
                              />
                                      <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                            </div>
                        </div>
                  </div>
                  <div class="flex my-4">
                        <div class="flex w-10">
                            <div class="mt-2.5 ml-1">
                                <svg class="fill-gray-500" xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div
                              class="relative g-form text-gray-700 rounded hover:cursor-pointer relative dark:text-gray-300 dark:hover:text-gray-100"
                            >   
                                <button v-if="descriptionHidden" @click="toggleDescriptionHidden" class="w-full text-start px-3 py-1 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-400 text-gray-500 rounded">Add Description</button>
                                <textarea v-if="!descriptionHidden"
                                          ref="descriptionTextarea" 
                                          type="text" 
                                          v-model="booking_details.description"
                                          @focus="handleTextareaFocus"
                                          @blur="handleTextareaBlur"
                                          class="w-full border-none rounded bg-gray-100 focus:ring-transparent dark:bg-gray-700" rows="3"></textarea>
                                <div v-if="!descriptionHidden" class="before-absolute bg-blue-600 -mt-2 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                            </div>
                        </div>
                  </div>
                  
        </div>  
        <div class="flex justify-end px-5 py-2">
            <div class="flex items-center">
                 <button @click="SubmitBookingForm" 
                         :class="{ 'pointer-events-none opacity-50' : slot_error != '' || attendees.length === 0 || Object.keys(this.temp_event).length === 0 }" 
                         class="bg-blue-600 rounded px-7 py-[9px] text-sm text-white focus:outline-none focus-visible:outline-2 hover:text-slate-100 hover:bg-blue-500 inline-flex items-center justify-center">
                      Save
                 </button>
            </div>
        </div>          
  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants";
import RequestMixin from "controllers/vue_components/mixins/request"
import FlashNotifications from "controllers/vue_components/flash_toast"
import SearchContactsDropdown from "controllers/vue_components/fields/search_contacts_dropdown";
import CustomSlotsDropdown from "controllers/vue_components/fields/custom_dropdown_slots";
import { useCalendarStore } from 'controllers/vue_components/calendar/store'
import TimelydoDropdown from "controllers/vue_components/fields/timelydo_dropdown"

export default {
    name: 'ExternalBookingForm',
    props: ['new_data'],
    emits: ['booking-success'],
    mixins: [Constants, RequestMixin],
    components:{
        SearchContactsDropdown, FlashNotifications, CustomSlotsDropdown, TimelydoDropdown
    },
    data() {
        return {
            data:{},
            events_list : [],
            temp_event : {},
            slot_error: '',
            attendees: [],
            booking_details: {
                ignore_slot_validation: true,
                name: '',
                event_id: null,
                description: '',
                start_at: null,
                end_at:null,
            },
            isTitleInputFocused: false,
            datePickerKey: 0,
            target_date: new Date(),
            target_time:{
                start: null,
                end: null,
            },
            eventsdropdownOpen: false,
            searchQuery: '',
            descriptionHidden: true,
            calendar_settings: [],
        };

    },
    methods: {
        async SubmitBookingForm(){
            if(Object.keys(this.temp_event).length === 0){
                this.$refs.flash.show("Select an event for booking", 'alert');
            }
            else if(this.attendees.length === 0){
                this.$refs.flash.show("Guest cant not be blank", 'alert');
            }
            else {
                let data_set = {
                    attendees: this.attendees,
                    booking: this.booking_details,
                }
                let resp = await this.axiosRequest('POST', '/api/v1/calendar/internal_bookings', data_set, false)
                if (resp.js_error == false && resp.response.success) {
                    this.$emit('booking-success');
                } else {
                    this.$refs.flash.show(resp.error.data.message, 'alert');
                }
            }
        },
        updateBookingDetailsName(newName) {
            this.booking_details.name = newName;
        },
        useCalendarStoreObj() {
            return useCalendarStore();
        },
        getCalendarSettings() {
            return this.useCalendarStoreObj().calendar_settings;
        },
        toggleEventsDropdown() {
            this.eventsdropdownOpen = !this.eventsdropdownOpen;
            this.searchQuery = '';

        },
        selectValue(event) {
            this.booking_details.event_id = event.id;
            this.booking_details.name = event.name;
            this.temp_event = event;
            this.eventsdropdownOpen = false;
        },
        updateEventData(data) {
            this.data = data;
            this.target_date = new Date(data.start)
            const startHours = this.target_date.getHours();
            const startMinutes = this.target_date.getMinutes();
            this.target_time.start = this.calendar_settings.time_format === '12_hours'
                ? this.formatTime12Hours(`${startHours}:${startMinutes}`)
                : `${startHours < 10 ? '0' : ''}${startHours}:${startMinutes < 10 ? '0' : ''}${startMinutes}`;

            const endTime = new Date(data.end);
            const endHours = endTime.getHours();
            const endMinutes = endTime.getMinutes();
            this.target_time.end = this.calendar_settings.time_format === '12_hours'
                ? this.formatTime12Hours(`${endHours}:${endMinutes}`)
                : `${endHours < 10 ? '0' : ''}${endHours}:${endMinutes < 10 ? '0' : ''}${endMinutes}`;

        },
        toggleDescriptionHidden() {
            this.descriptionHidden = !this.descriptionHidden;
            if (!this.descriptionHidden) {
                this.$nextTick(() => {
                    this.$refs.descriptionTextarea.focus();
                });
            }
        },
        handleTextareaFocus() {
            this.descriptionHidden = false;
        },
        handleTextareaBlur() {
            if (this.booking_details.description.trim() === '') {
                this.descriptionHidden = true;
            }
        },
        updateSlotDropdownValue(value){
            let attr = Object.keys(value)[0];
            this.target_time[attr] = value[attr];
        },
        updateAttendeeEmail(value) {
            this.attendees = value;
        },
        generateStartTimeSlots() {
            const timeSlots = [];
            for (let hours = 0; hours < 24; hours++) {
                for (let minutes = 0; minutes < 60; minutes += 15) {
                    if (!(hours === 23 && minutes === 45)) {
                        const formattedHours = String(hours).padStart(2, '0');
                        const formattedMinutes = String(minutes).padStart(2, '0');
                        const time = `${formattedHours}:${formattedMinutes}`;
                        timeSlots.push(time);
                    }
                }
            }
            return this.calendar_settings.time_format === '12_hours'
                ? timeSlots.map(time => this.formatTime12Hours(time))
                : timeSlots;
        },
        generateEndTimeSlots() {
            const timeSlots = [];
            let startHour = parseInt(this.target_time.start.split(':')[0]);
            const startMinute = parseInt(this.target_time.start.split(':')[1]);
            const is12HourFormat = this.calendar_settings.time_format === '12_hours';

            if (is12HourFormat) {
                const isPM = /PM/i.test(this.target_time.start);
                startHour = isPM ? (startHour % 12) + 12 : startHour % 12;
            }

            for (let hours = startHour; hours < 24; hours++) {
                for (let minutes = 0; minutes < 60; minutes += 15) {
                    const currentHour = hours;
                    const currentMinute = minutes;

                    if (
                        (currentHour > startHour || (currentHour === startHour && currentMinute > startMinute))
                    ) {
                        const formattedHours = String(currentHour).padStart(2, '0');
                        const formattedMinutes = String(currentMinute).padStart(2, '0');
                        const time = `${formattedHours}:${formattedMinutes}`;
                        timeSlots.push(time);
                    }
                }
            }

            return is12HourFormat
                ? timeSlots.map(time => this.formatTime12Hours(time))
                : timeSlots;
        },

        formatDateTime(date, time) {
            const formattedDate = new Date(date);

            if (isNaN(formattedDate.getTime())) {
                console.error('Invalid date:', date);
                return null;
            }

            const [hours, minutes] = time.split(':');

            const validHours = parseInt(hours, 10);
            const validMinutes = parseInt(minutes, 10);

            if (isNaN(validHours) || isNaN(validMinutes) || validHours < 0 || validHours >= 24 || validMinutes < 0 || validMinutes >= 60) {
                console.error('Invalid time:', time);
                return null;
            }

            formattedDate.setHours(validHours, validMinutes, 0, 0);

            // Validate the resulting date after setting time components
            if (isNaN(formattedDate.getTime())) {
                console.error('Invalid date after setting time components:', date, time);
                return null;  // Or you can return a default value or throw an error
            }

            return formattedDate.toISOString();
        },

        formatTime12Hours(time) {
            const [hours, minutes] = time.split(':');
            const formattedHours = (hours % 12) || 12;
            const formattedMinutes = minutes.padStart(2, '0');
            const amPm = hours >= 12 ? 'PM' : 'AM';
            return `${formattedHours}:${formattedMinutes} ${amPm}`;
        }

    },
    computed: {
        formattedDate() {
            const options = { weekday: 'long', month: 'long', day: 'numeric' };
            return this.target_date.toLocaleDateString('en-US', options);
        },
        filteredEvents() {
            const query = this.searchQuery.toLowerCase();
            const filteredevents = this.useCalendarStoreObj().calendars_list.filter((event) => {
                return (
                    event.name.toLowerCase().includes(query)
                );
            });

            filteredevents.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });

            return filteredevents;
        },
    },
    async created() {
        this.calendar_settings = this.getCalendarSettings();
        if (this.new_data) {
            this.updateEventData(this.new_data);
        }
        this.events_list = useCalendarStore().host_events;
    }
};
</script>
